import { createContext, useContext, useReducer } from 'react';
import inlineEditReducer, { initialState } from 'framework-listing-lib/internal/FrameworkDataTable/reducers/inlineEditReducer';
import InlineEditSaveBar from 'framework-listing-lib/internal/FrameworkDataTable/components/InlineEditSaveBar';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const InlineEditDispatchContext = /*#__PURE__*/createContext(undefined);
const InlineEditStateContext = /*#__PURE__*/createContext(undefined);
export default function InlineEditProvider({
  children
}) {
  const [state, dispatch] = useReducer(inlineEditReducer, initialState);
  return /*#__PURE__*/_jsx(InlineEditDispatchContext.Provider, {
    value: dispatch,
    children: /*#__PURE__*/_jsx(InlineEditStateContext.Provider, {
      value: state,
      children: /*#__PURE__*/_jsxs(_Fragment, {
        children: [children, /*#__PURE__*/_jsx(InlineEditSaveBar, {})]
      })
    })
  });
}
export function useInlineEditDispatch() {
  const context = useContext(InlineEditDispatchContext);
  if (context === undefined) {
    throw new Error('useInlineEditDispatch must be used within a InlineEditProvider');
  }
  return context;
}
export function useInlineEditState() {
  const context = useContext(InlineEditStateContext);
  if (context === undefined) {
    throw new Error('useInlineEditState must be used within a InlineEditProvider');
  }
  return context;
}